import { render, staticRenderFns } from "./ChatMensagem.vue?vue&type=template&id=6e948b4c&scoped=true"
import script from "./ChatMensagem.vue?vue&type=script&lang=js"
export * from "./ChatMensagem.vue?vue&type=script&lang=js"
import style0 from "./ChatMensagem.vue?vue&type=style&index=0&id=6e948b4c&prod&lang=css"
import style1 from "./ChatMensagem.vue?vue&type=style&index=1&id=6e948b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e948b4c",
  null
  
)

export default component.exports